module.exports = __webpack_public_path__ + "img/buy_none.542cd819.png";